import { Button, HStack, Switch, Text } from '@chakra-ui/react';

export type GridV1EditorMode = 'edit' | 'view';

interface GridV1ToolbarProps {
  mode: GridV1EditorMode;
  onModeChange: (mode: GridV1EditorMode) => void;
  onAddCell: () => void;
}

export function GridV1Toolbar({
  mode,
  onModeChange,
  onAddCell,
}: GridV1ToolbarProps) {
  const isEditMode = mode === 'edit';

  return (
    <HStack
      className="grid-v1-toolbar"
      gap={3}
      py={2}
      px={2}
      flexShrink={0}
      justify="space-between"
      wrap="wrap"
    >
      <HStack gap={2}>
        <Switch.Root
          checked={isEditMode}
          onCheckedChange={(e) => onModeChange(e.checked ? 'edit' : 'view')}
        >
          <Switch.HiddenInput />
          <Switch.Control>
            <Switch.Thumb />
          </Switch.Control>
        </Switch.Root>
        <Text fontSize="sm" color="fg.muted">
          Edit mode
        </Text>
      </HStack>
      {isEditMode ? (
        <Button size="sm" variant="outline" onClick={onAddCell}>
          Add cell
        </Button>
      ) : null}
    </HStack>
  );
}
